import { graphql } from 'react-relay';

const closeAccount = graphql`
  mutation CloseAccountMutation(
    $accountId: ID!
  ) {
    closeAccount(
      accountId: $accountId
    ) {
      account {
        id
        updatedAt
        clientaccount {
          id
          accountStatus
          updatedAt
        }
      }
    }
  }
`;

export default closeAccount;
